// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"_E-z","smallCardRow":"aF-z","largeCardRow":"bF-z","productSearchRow":"cF-z","curatedRow":"dF-z"};